import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@project/translate';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';

import { ButtonModule, CardModule, FormElementsModule } from '@lib/ui';

import { SessionDetailsProceduresComponent } from './session-details-procedures.component';
import { ProceduresSelectComponent } from './procedures-select/procedures-select.component';
import { ProceduresSelectListComponent } from './procedures-select-list/procedures-select-list.component';
import { ProceduresCombosService } from './procedures-combos.service';
import { SpinnerFormControlModule } from '../../../project/components/spinner-form-control/spinner-form-control.module';
import { CidSelectModule } from '../../../project/modules/session-details-shared/session-details-shared-medical-record/cid-select/cid-select.module';
import { ProceduresManualSelectComponent } from './procedures-manual-select/procedures-manual-select.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
  declarations: [
    SessionDetailsProceduresComponent,
    ProceduresSelectComponent,
    ProceduresSelectListComponent,
    ProceduresManualSelectComponent,
  ],
  exports: [
    SessionDetailsProceduresComponent,
    ProceduresSelectComponent,
    ProceduresSelectListComponent,
    ProceduresManualSelectComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    FormElementsModule,
    CardModule,
    SpinnerFormControlModule,
    ButtonModule,
    CidSelectModule,
    MatInputModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
  ],
  providers: [ProceduresCombosService],
})
export class ProceduresModule {}
